import { createContext } from "react";

const QuimioContext = createContext();

export default QuimioContext;
